export const LOCATION_UPDATE_DEBOUNCE_MS = 300;
